import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { commonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import SubscriberDeleteDialg from "@saleor/subscribers/components/SubscriberDeleteDialog";
import SubscriberPage, {
  SubscriberPageFormData
} from "@saleor/subscribers/components/SubscriberPage";
import {
  useSubscriptionDeleteMutation,
  useSubscriptionUpdateMutation
} from "@saleor/subscribers/mutations";
import { useSubscriptionDetailsQuery } from "@saleor/subscribers/queries";
import {
  subscriberListUrl,
  subscriberUrl,
  SubscriberUrlDialog,
  SubscriberUrlQueryParams
} from "@saleor/subscribers/urls";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import React from "react";
import { useIntl } from "react-intl";

interface SubscriberDetailsProps {
  id: string;
  params: SubscriberUrlQueryParams;
}

const SubscriberDetails: React.FC<SubscriberDetailsProps> = ({
  id,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();
  const [openModal, closeModal] = createDialogActionHandlers<
    SubscriberUrlDialog,
    SubscriberUrlQueryParams
  >(navigate, params => subscriberUrl(id, params), params);

  const { data, loading } = useSubscriptionDetailsQuery({
    variables: {
      id
    }
  });

  const [subscriberDelete, subscriberDeleteOpts] = useSubscriptionDeleteMutation({
    onCompleted: data => {
      if (data.subscriptionDelete.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "subscriber delete"
          })
        });
        navigate(subscriberListUrl());
      }
    }
  });

  const [subscriberUpdate, subscriberUpdateOpts] = useSubscriptionUpdateMutation({
    onCompleted: data => {
      if (data.subscriptionUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
      }
    }
  });

  const handleUpdate = async (data: SubscriberPageFormData) => {
    const input = {
      ...data
    };

    const result = await subscriberUpdate({
      variables: {
        id,
        input
      }
    });

    return result.data.subscriptionUpdate.errors;
  };
  return (
    <>
      <SubscriberPage
        errors={subscriberUpdateOpts.data?.subscriptionUpdate.errors || []}
        subscriber={maybe(() => data.subscription)}
        disabled={loading}
        onBack={() => navigate(subscriberListUrl())}
        saveButtonBarState={subscriberUpdateOpts.status}
        onDelete={() => openModal("remove")}
        onSubmit={handleUpdate}
        title={"details"}
      ></SubscriberPage>
      <SubscriberDeleteDialg
        open={params.action === "remove"}
        title={maybe(() => data.subscription.email, "……")}
        confirmButtonState={subscriberDeleteOpts.status}
        onClose={closeModal}
        onConfirm={() =>
          subscriberDelete({
            variables: {
              id
            }
          })
        }
      />
    </>
  );
};

export default SubscriberDetails;
